import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sun, ArrowRight } from 'lucide-react';
import { fetchSlokasByChapter } from '../api/client';
import { DEFAULT_LANGUAGE } from '../utils/defaultLanguage';
import SlokaArtImage from './SlokaArtImage';

// Verse counts per chapter (Chapters 1–18)
const VERSE_COUNTS = [47, 72, 43, 42, 29, 47, 30, 28, 34, 42, 55, 20, 35, 27, 20, 24, 28, 78];
const TOTAL = VERSE_COUNTS.reduce((a, b) => a + b, 0);

function todayVerse() {
  const epochDays = Math.floor(Date.now() / 86400000);
  let idx = epochDays % TOTAL;
  for (let ch = 0; ch < VERSE_COUNTS.length; ch++) {
    if (idx < VERSE_COUNTS[ch]) return { chapterNumber: ch + 1, slokaNumber: idx + 1 };
    idx -= VERSE_COUNTS[ch];
  }
  return { chapterNumber: 1, slokaNumber: 1 };
}

const CACHE_KEY = 'gita-daily-verse';

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { date, data } = JSON.parse(raw);
    if (date === new Date().toDateString()) return data;
  } catch {}
  return null;
}

function writeCache(data) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ date: new Date().toDateString(), data }));
  } catch {}
}

const DailyVerse = () => {
  const [sloka, setSloka] = useState(null);
  const { chapterNumber, slokaNumber } = todayVerse();

  useEffect(() => {
    const cached = readCache();
    if (cached) { setSloka(cached); return; }

    fetchSlokasByChapter(DEFAULT_LANGUAGE, chapterNumber)
      .then((slokas) => {
        const found = slokas.find((s) => s.slokaNumber === slokaNumber) || slokas[0];
        if (found) { setSloka(found); writeCache(found); }
      })
      .catch(() => {});
  }, [chapterNumber, slokaNumber]);

  if (!sloka) return null;

  return (
    <div className="daily-verse-card">
      <div className="daily-verse-art">
        <SlokaArtImage
          chapterNumber={sloka.chapterNumber}
          slokaNumber={sloka.slokaNumber}
          fallback="chapter"
          alt=""
          className="daily-verse-img"
        />
      </div>
      <div className="daily-verse-body">
        <div className="flex items-center gap-2 mb-3">
          <Sun className="w-4 h-4 text-gita-gold" />
          <span className="text-xs font-semibold tracking-widest text-gita-gold uppercase">Today's Verse</span>
        </div>
        <p className="text-sm font-medium text-gita-maroon mb-1">
          Chapter {sloka.chapterNumber} · Verse {sloka.slokaNumber}
        </p>
        <p className="text-base leading-relaxed text-gray-800 mb-3 line-clamp-2 font-serif">
          {sloka.sloka}
        </p>
        <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-2">
          {sloka.meaning}
        </p>
        <Link
          to={`/sloka/${sloka._id}`}
          className="btn-primary text-sm self-start flex items-center"
        >
          Read verse
          <ArrowRight className="ml-2 w-3 h-3" />
        </Link>
      </div>
    </div>
  );
};

export default DailyVerse;
